<template>
  <v-card>
    <v-card-title>品種別上限本数設定
      <v-spacer/>
      <v-btn @click="add">{{$t('app.buttons.add')}}</v-btn>
      <v-btn @click="remove">{{$t('app.buttons.remove')}}</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="value"
      :rows-per-page-items="[10]"
      class="elevation-0"
      hide-actions
      item-key="seq"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>
          <lookup :value="props.item.productCode" url="products/kv"/>
        </td>
        <td>{{props.item.upperLimit}}</td>
      </template>
    </v-data-table>
    <add-variety-dialog ref="addVarietyDlg"/>
  </v-card>
</template>
<script>
import AddVarietyDialog from './AddVarietyDialog'

export default {
  components: { AddVarietyDialog },
  props: ['value'],
  data() {
    return {
      headers: [
        { text: '品種', value: 'productCode' ,sortable:false},
        { text: '受入上限本数', value: 'upperLimit',sortable:false }
      ],
      selected: []
    }
  },
  methods: {
    add() {
      this.$refs.addVarietyDlg.popup().then(r => {
        this.$emit('input', [
          ...this.value,
          { ...r, seq: new Date().getTime() }
        ])
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$emit(
            'input',
            this.value.filter(i => this.selected.indexOf(i) === -1)
          )
          this.selected = []
          this.$message('', '削除成功')
        }
      )
    }
  }
}
</script>
